import type { Game } from '../../types/game'
import { SeasonIcon } from '../shared/ResourceIcon'
import { UiIcon } from './UiIcon'
import { assetUrl } from '../../utils/assets'

function calculateFavorForEvent(eventIndex: number, steps: Record<number, number>): number {
  let nextEventAt = 0
  for (let n = 0; n <= eventIndex; n += 1) {
    const stepSizeIndex = Math.max(...Object.keys(steps).map(Number).filter((step) => step <= n))
    nextEventAt += steps[stepSizeIndex]
  }
  return nextEventAt
}

interface MobileTopBarProps {
  game: Game
  isCurrentTurn: boolean
  onPass: () => void
  onOpenFlowers: () => void
  onOpenPollinate: () => void
  onOpenDonate: () => void
  onOpenEvolutions: () => void
  onOpenMenu: () => void
}

export function MobileTopBar({
  game,
  isCurrentTurn,
  onPass,
  onOpenFlowers,
  onOpenPollinate,
  onOpenDonate,
  onOpenEvolutions,
  onOpenMenu,
}: MobileTopBarProps) {
  const eventCounter = game.event_handler.event_counter ?? 0
  const steps = game.event_handler.event_trigger_steps
  const previousEventFavor = eventCounter > 0 ? calculateFavorForEvent(eventCounter - 1, steps) : ''
  const nextEventFavor = calculateFavorForEvent(eventCounter, steps)
  const upcomingEventFavor = calculateFavorForEvent(eventCounter + 1, steps)

  return (
    <div id="mobile-top-bar" className="mobile-top-bar">
      <div id="mobile-favor-tracker" className="favor-tracker mobile-favor-tracker">
        <div className="favor-tracker-markers mobile-top-bar-trackers">
          {game.players.map((player) => (
            <div key={player.color} className={`favor-tracker-marker ${player.color}`}>
              {player.n_favor}
            </div>
          ))}
        </div>
      </div>
      <div id="mobile-season-tracker" className="season-tracker mobile-season-tracker">
        <div className="season-tracker-seasons mobile-top-bar-trackers">
          {(['spring', 'summer', 'autumn', 'winter'] as const).map((season) => (
            <SeasonIcon
              key={season}
              season={season}
              inverted={season === game.current_season}
              className={season === game.current_season ? 'current-season' : undefined}
            />
          ))}
        </div>
      </div>
      <div id="mobile-queen-tracker" className="queen-tracker mobile-queen-tracker">
        <div className="queen-tracker-content mobile-top-bar-trackers">
          <div className="queen-tracker-marker">{game.queen.health}</div>
        </div>
      </div>
      <div id="mobile-event-tracker" className="colony-collapse-event-tracker mobile-event-tracker">
        <div className="colony-collapse-event-tracker-content mobile-top-bar-trackers">
          <div>{previousEventFavor}</div>
          <div>{nextEventFavor}</div>
          <div>{upcomingEventFavor}</div>
        </div>
      </div>
      <div className="mobile-top-bar-button-shell">
        <div className="mobile-top-bar-button-inner">
          <div id="mobile-pass-turn" className="mobile-top-bar-button mobile-pass-button" title="Pass" onClick={onPass}>
            <UiIcon name="pass" className="mobile-nav-icon" />
          </div>
          <div
            id="mobile-open-flowers"
            className="mobile-top-bar-button"
            title="Flowers"
            onClick={() => onOpenFlowers()}
          >
            <img src={assetUrl('images', 'flower.svg')} alt="" className="mobile-nav-icon icon" />
          </div>
          <div
            id="mobile-open-pollinate"
            className="mobile-top-bar-button"
            title="Pollinate"
            onClick={() => onOpenPollinate()}
          >
            <UiIcon name="pollinate" className="mobile-nav-icon" />
          </div>
          <div
            id="mobile-open-donate"
            className="mobile-top-bar-button"
            title="Donate"
            onClick={onOpenDonate}
          >
            <UiIcon name="donate" className="mobile-nav-icon" />
          </div>
          <div
            id="mobile-open-evolutions"
            className="mobile-top-bar-button"
            title="Evolutions"
            onClick={onOpenEvolutions}
          >
            <img src={assetUrl('images', 'evolution.svg')} alt="" className="mobile-nav-icon icon" />
          </div>
          <div id="mobile-open-menu" className="mobile-top-bar-button" title="Menu" onClick={onOpenMenu}>
            <UiIcon name="menu" className="mobile-nav-icon" />
          </div>
        </div>
      </div>
    </div>
  )
}
